<template>
  <div class="detail">
    <div class="demand">
      <div class="title">需求信息</div>
      <ul>
        <el-tooltip effect="dark" :content="info.title" placement="bottom" :disabled="isShowTooltip">
          <li @mouseover="onMouseOver('title')">工程名称： <span ref="title"> {{ info.title }} </span></li>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" :content="info.need" placement="bottom" :disabled="isShowTooltip">
          <li @mouseover="onMouseOver('need')">用工需求：<span ref="need">{{ info.need }}</span></li>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" :content="info.introduction" placement="bottom" :disabled="isShowTooltip">
          <li @mouseover="onMouseOver('introduction')">工程简介：<span ref="introduction">{{ info.introduction }}</span></li>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" :content="info.ability" placement="bottom" :disabled="isShowTooltip">
          <li @mouseover="onMouseOver('ability')">工程所需技能：<span ref="ability">{{ info.ability }}</span></li>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" :content="info.qualification" placement="bottom" :disabled="isShowTooltip">
          <li @mouseover="onMouseOver('qualification')">工程所需资质：<span ref="qualification">{{ info.qualification }}</span></li>
        </el-tooltip>
      </ul>
      <ul>
        <el-tooltip class="item" effect="dark" :content="info.address" placement="bottom" :disabled="isShowTooltip">
          <li @mouseover="onMouseOver('address')">工作地点：<span ref="address">{{ info.address }}</span></li>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" :content="info.instruction" placement="bottom" :disabled="isShowTooltip">
          <li @mouseover="onMouseOver('instruction')">接单说明：<span ref="instruction">{{ info.instruction }}</span></li>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" :content="formatStatus(info.status)" placement="bottom" :disabled="isShowTooltip">
          <li @mouseover="onMouseOver('status')">状态：<span ref="status">{{ formatStatus(info.status) }}</span></li>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" :content="info.createTime" placement="bottom" :disabled="isShowTooltip">
          <li @mouseover="onMouseOver('createTime')">创建时间：<span ref="createTime">{{ info.createTime }}</span></li>
        </el-tooltip>
      </ul>
      <!--<ul>-->
        <!--<li>计划工程总额（元）：<span>{{ info.price }}</span></li>-->
        <!--<li>人数限制：<span>{{ info.number }}</span></li>-->
        <!--<li>预计工期（天）：<span>{{ info.days }}</span></li>-->
        <!--<li>单价上限（人/天）：<span>{{ info.up }}</span></li>-->
        <!--<li>单价下限（人/天）：<span>{{ info.down }}</span></li>-->
        <!--<li>服务费：<span>{{ info.fwf }}</span></li>-->
      <!--</ul>-->
    </div>
    <div class="info">
      <div class="title">
        订单信息
        <span>（当前状态：{{ formatStatusD(this.order.status) }}）</span>
      </div>
      <ul>
        <li>
          计划单价：<span>{{ order.money }}</span>
        </li>
        <li>
          计划天数：<span>{{ order.day }}</span>
        </li>
        <li>
          计划总金额：<span>{{ order.price }}</span>
        </li>
        <li>
          实际单价：<span>{{ order.money1 }}</span>
        </li>
        <li>
          实际天数：<span>{{ order.day1 }}</span>
        </li>
        <li>
          实际总金额：<span>{{ order.price1 }}</span>
        </li>
      </ul>
      <div class="info">
        <div style="display: flex;justify-content: center;padding: 20px;">
          <el-button type="info" size="medium" @click="queren" v-if="info.status ==='2' && order.status === '3'">结算单确认</el-button>
          <el-button type="info" size="medium" @click="payment" v-if="info.status ==='7' && order.status === '5'">确认收款</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../http/electrician/api.js";
import { mapGetters } from 'vuex';

export default {
  name: "detail",
  data() {
    return {
      id: '',
      info:{},
      order:{},
      isShowTooltip: false
    };
  },
  methods: {
    getDetail(){
      this.info = {};
      this.order = {};
      api.orderDetail(this.id).then(res => {
        if(res){
          this.info = res.need;
          this.order = res.order;
        }
      });
    },
    queren(){
      api.eleAcc({id: this.order.id, needId: this.id}).then(res => {
        this.getDetail();
      });
    },
    payment(){
      api.getMoney({id: this.order.id, needId: this.id}).then(res => {
        this.getDetail();
      });
    },
    // 格式化
    formatStatus(obj){
      const data = this.needStatus.find(item => item.value === obj);
      if(data){
        return data.label;
      }
      return "";
    },
    formatStatusD(obj){
      const data = this.orderStatus.find(item => item.value === obj);
      if(data){
        return data.label;
      }
      return "";
    },
    onMouseOver(str) { // 内容超出，显示文字提示内容
      const tag = this.$refs[str];
      const parentWidth = tag.parentNode.offsetWidth; // 获取元素父级可视宽度
      const contentWidth = tag.offsetWidth; // 获取元素可视宽度
      let width = 70;
      if(str=='ability' || str =='qualification'){
        width = 98;
      }
      this.isShowTooltip = contentWidth <= (parentWidth-width);
    }
  },
  mounted: function() {
    //模板编译/挂载之后
    this.id = this.$route.query.id;
    this.getDetail(this.id);
  },
  computed:{
    ...mapGetters(['needStatus', 'orderStatus'])
  }
};
</script>

<style lang="less" scoped="scoped">
.detail {
  width: 100%;
}

.demand,
.info {
  width: 100%;
  background: @vue-bg-color;
  margin-bottom: @vue-spacing-col-lg;
  padding: 0px @vue-spacing-row-base;
  box-sizing: border-box;

  .title {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid @vue-border-color;
    font-weight: bold;

    span {
      color: orange;
      font-size: @vue-font-size-sm - 2;
    }
  }

  .userinfo {
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    line-height: 80px;

    .avatar {
      width: 60px;
      height: 60px;
      border-radius: @vue-border-radius-circle;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .name,
    .time {
      height: 100%;
      display: flex;
      align-items: center;
      padding-left: @vue-spacing-row-base;
      box-sizing: border-box;
      margin-right: @vue-spacing-row-base;
    }

    .time {
      color: @vue-text-color-red;
    }

    .score {
      height: 100%;

      .personal-score {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 20px;
          height: 20px;
          margin-right: 4px;
        }

        span {
          font-size: @vue-font-size-base;
          color: @vue-text-color-red;
          padding: 5px 10px;
          box-sizing: border-box;
          border-radius: @vue-border-radius-base;
          line-height: 20px;
        }
      }
    }
  }
}

.demand, .info {
  padding-bottom: @vue-spacing-col-base;

  ul, .desc {
    width: 100%;
    display: flex;
  }

  ul {
    li {
      width: 20%;
      padding: 10px 10px;
      box-sizing: border-box;
      line-height: 30px;
      color: @vue-text-color-grey;
      font-size: @vue-font-size-sm - 2;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      span {
        color: @vue-text-color;
      }
    }
  }

  .desc {
    justify-content: space-between;
    font-size: @vue-font-size-sm - 2;

    .key {
      width: 80px;
      line-height: 40px;
      padding: 0px 10px;
      box-sizing: border-box;
      color: @vue-text-color-grey;
    }

    .value {
      width: calc(100% - 80px);
      line-height: 40px;
      background: @vue-bg-color-grey;
      padding: 0px @vue-spacing-row-base;
      box-sizing: border-box;
    }
  }
}

.info {
  ul {
    padding: @vue-spacing-col-base 0px;
    box-sizing: border-box;

    li {
      width: 20%;
      padding: 10px 0px;
      box-sizing: border-box;
      line-height: 30px;
      color: @vue-text-color-grey;
      font-size: @vue-font-size-sm - 2;

      span {
        color: @vue-text-color;
      }
    }
  }
}



.imgs {
  width: 160px;
  height: 120px;
}
</style>
